module.exports = __webpack_public_path__ + "media/images/static/consult/banner-a415773088d08f5547e0ae96b76dd840.png";